	import React, {
	Component,
	PropTypes
} from 'react';
import render from "react-dom";
import {
	Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
    import LongSearchInput from 'CONFIG/component/search/longSearchInput'
    import {ellaUrl} from '../../../path.config'
import userService from 'SERVICES/ella/userService'
	import {resultTip,language,pageOption} from 'UTIL/common'
    import ellaService from 'SERVICES/purifier/ella/ellaService'
    import Tip from 'COMPONENT/tip'
    import BoxHeader from "CONFIG/component/boxHeader"
    import ModalDel from 'COMPONENT/ModalDel'
    import Modal from 'COMPONENT/modal'
export default class UserTypeIndex extends Component {
	constructor(props) {
		super(props);
		this.handle = this.handle.bind(this);
		this.delList = this.delList;
		this.delClick = this.delClick;
		this.search = this.search.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.state = {
			list: [],
			size: 10,
			current: 1,
			total: 0,
			delRow: {id:"",name:""},
			url: ellaUrl
		};
	}
	componentDidMount() {
		this.onPageChange(this.state.current,this.state.size);
	}
	handle(cell, row) {
		return (<div>
			<Link  to = {"/ella/user/usertype/userTypeEdit/"+row.id} className="btn btn-sm btn-info">
				{language()['edit']}
		            </Link>&nbsp;&nbsp;
			<a className="btn btn-sm btn-danger" data-target="#tipModal" data-toggle="modal"
			   onClick={this.delList.bind(this,row.id,row.roleName)}>{language()['delete']}</a>&nbsp;&nbsp;
			{/*<Link  to = {"/ella/user/userType/extendsValue/"+row.id} className="btn btn-warning btn-sm">*/}
				{/*扩展属性*/}
			{/*</Link>&nbsp;&nbsp;*/}

		</div>);

	};
	delList(id, name) {
		var delRow = {
            id:id,
            name:name,
        };
        this.setState({
            delRow:delRow
        });
        console.log(delRow);
	};
	onPageChange(page, sizePerPage, e) {
		const name = $.trim($("#name").val());
		const json = {
			current:page,
            size:sizePerPage,
			search: name
		};
		const url =  this.state.url + "/usertype/searchList";
		const data = JSON.stringify(json);
		userService.getUserTypeList({data}).then(body=>{
            if(body.data !=null){
                this.setState({
                    current: body.data.page.current,
                    size: body.data.page.size,
                    list : body.data.page.records,
                    total : body.data.page.total
                })}
		})
	}
	search() {
        this.onPageChange(this.state.current,this.state.size);
	}

	delClick(id){
        var self = this;
        userService.userTypeDel(id).then(body=>{
        	this.onPageChange(this.state.current,this.state.size);
            if (body.code == 8001) {
                $("#success_msg").text(body.msg);
                $("#success_tip").removeClass("hidden");
                setTimeout(function() {
                    $("#success_tip").addClass("hidden");
                }, 2000);
            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 2000);
            }
		});
    }
    reset(){
        $("#name").val('');
        this.onPageChange(1,10)
    }

	render() {
        let options = pageOption(this.state.current,this.state.size);
		options['onPageChange'] = this.onPageChange.bind(this);
		return (
			<div >
				<section className="content-header " >
			               	 <h1> {language()['userManage']} <small>{language()['userType']}</small> </h1>
			            </section>
			             <section className="content" >
		             		<div className="box box-primary color-palette-box">
		                 			 <div className="box-header with-border">
		                   				 <i className="fa fa-list"></i>
		                    				<h3 className="box-title">{language()['userTypeList']}</h3>
		                    				<div style={{marginRight:"10px",float:"right"}}>
						                      <Link  to = "/ella/user/userType/userTypeAdd" className="btn btn-success btn-md"  >
						                        	<i className="fa fa-plus-circle"></i> {language()['add']}
						                      </Link>
						            </div>
		                  			</div>
		                  			<div className="box-body">
		                       				<Tip ids=""/>

										<div className="title-box">
											<div className="clearfix">
											  <LongSearchInput id="name" name={language()['userTypeName']}/>
												<button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>&nbsp;&nbsp;
												<button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>
                                                    {language()['resetting']}
												</button>
											</div>
										</div>
			                    			<div >
												<BootstrapTable data = {this.state.list}  remote={true} height={'auto'} fetchInfo={{ dataTotalSize: this.state.total }} striped hover pagination={true} options={options} ref='table' >
													<TableHeaderColumn isKey dataField='id' hidden={true} > id</TableHeaderColumn>
													<TableHeaderColumn dataField='name' width="150"> {language()['userTypeName']} </TableHeaderColumn>
													<TableHeaderColumn  dataField='remark' width="300">{language()['remark']}</TableHeaderColumn>
													<TableHeaderColumn  dataFormat={this.handle}  width="120" columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
												</BootstrapTable>
		                  				</div>
		                  			</div>
		                		</div>
		             	</section>
				<ModalDel delModSure={this.delClick.bind(this,this.state.delRow.id)} id="tipModal"/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/ella/user/userType/userTypeIndex.js